<h5 *ngIf="ecashView" class="text-black mb-3 d-lg-block d-none">
  {{ 'payment.history.page.title' | translate }}
</h5>

<div class="card border-secondary mt-3 mt-lg-0">
  <div [ngClass]="{ 'card-body-ecash': ecashView, 'card-body-account': accountView }">
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between">
      <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
      <button
        type="button"
        class="search-button font-praktika-bold mb-2 d-block btn btn-secondary rounded text-white border-secondary"
        (click)="search()"
      >
        {{ 'payment.history.button.search' | translate }}
      </button>
    </div>
  </div>
</div>

<fgb-transaction-list
  *ngIf="selectedValues"
  [startDate]="selectedValues.start"
  [endDate]="selectedValues.end"
  [memberId]="memberId"
  [transactionType]="selectedValues.type"
></fgb-transaction-list>
